import { render, staticRenderFns } from "./RemoteBubble.vue?vue&type=template&id=43a97b76&"
import script from "./RemoteBubble.vue?vue&type=script&lang=js&"
export * from "./RemoteBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports